import { store } from "../store/store";
import { hasAccessToRoute } from "./route-access";

export const authGuard = async (to, from, next) => {
  // Cold page load (manual URL / reload) leaves apiKey null in state even when
  // a valid token sits in localStorage. Rehydrate it here and await the result,
  // then resolve the navigation via next() ourselves. Letting checkAuth resolve
  // the navigation with its own router.push raced with this pending navigation
  // and silently desynced the back button after a from-scratch load (#11050).
  if (!store.state.apiKey) {
    await store.dispatch("checkAuth", to);
  }

  if (store.state.apiKey) {
    hasAccessToRoute(to) ? next() : next("/home");
  } else {
    // checkAuth handled the redirect (login / expiry / SSO token); abort this nav.
    next(false);
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js